import {
    GET_APPOINTMENT_VISITOR_LIST,
    GET_APPOINTMENT_VISITOR_REQUEST,
    GET_APPOINTMENT_VISITOR_FAILURE,
    GET_APPOINTMENT_VISITOR_LIST_SUCCESS,
} from '../constants/appointment-visitor.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
    count: 0,
    page: 1,
};

export const appointmentVisitorListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_APPOINTMENT_VISITOR_LIST:
            return {
                ...state,
                loading: true,
                data: action.payload,
            };
        case GET_APPOINTMENT_VISITOR_REQUEST:
            return {
                ...state,
                loading: true,
                page: 1,
            };
        case GET_APPOINTMENT_VISITOR_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: 'Error',
            };
        case GET_APPOINTMENT_VISITOR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                count: action.count,
            };
        default:
            return {
                ...state,
                loading: false,
            };
    }
};
